<template>
    <ContainerWithMenu>
        <div class="page-content">
            <div class="row">
                <div class="col-xs-12 col-sm-6">
                    <h1 class="h2 margin-bottom-20">{{rate.name}}</h1>
                </div>
                <div class="col-xs-12 col-sm-6 text-right">
                    <button class="btn btn-primary btn-action-mobile" v-if="isCourse" @click="showAddMultipleAppointmentModal">
                        <i class="las la-plus"></i>
                        <span class="button-text">{{ $t('views.rate_detail.add_new_dates') }}</span>
                    </button>
                    <button v-else class="btn btn-primary btn-action-mobile" @click="showAddSingleAppointmentModal">
                        <i class="las la-plus"></i>
                        <span class="button-text">{{ $t('views.rate_detail.add_appointment') }}</span>
                    </button>
                </div>
            </div>
            <div class="row">
                <div class="col-xs-12 col-sm-7">
                    <div class="panel panel-default margin-bottom-40">
                        <div class="panel-heading">
                            {{ $t('views.rate_detail.title_configuration') }}
                        </div>
                        <div class="panel-body">
                            <RateForm :rate-prop="rate" @change="onChangeRate"></RateForm>
                        </div>
                        <div class="panel-footer">
                            <a id="save-reservation-btn" class="btn btn-default btn-lg btn-block margin-bottom-10" href="" @click.stop.prevent="saveRateClick"><i class="las la-check"></i>{{ $t('common.save_change') }}</a>
                            <a class="text-danger margin-bottom-20" href="" @click.prevent.stop="showDeleteRateModal">{{ $t('views.rate_detail.delete') }}</a>
                        </div>
                    </div>
                </div>
                <div class="col-xs-12 col-sm-5">
                    <h4>{{ $t('views.rate_detail.appointments_title') }}</h4>
                    <table v-if="rate.appointments_set && rate.appointments_set.length > 0" class="table table-condensed">
                        <tbody>
                        <tr v-for="appointment_set in rate.appointments_set" v-bind:key="appointment_set.id" >
                            <td v-if="appointment_set.appointments.length === 1">
                                <span style="text-transform: capitalize;">{{getLongDateFromISO(appointment_set.appointments[0].date)}}</span><br>
                                <span class="text-muted">
									{{appointment_set.appointments[0].chaired_admin.first_name}} {{appointment_set.appointments[0].chaired_admin.last_name}} ({{appointment_set.reservation_count}}/{{appointment_set.max_participant}})
									</span>
                                <div v-if="appointment_set.is_online">
                                    <span class='label label-default'>{{ $t('common.online')}}</span>
                                </div>
                            </td>
                            <td v-else>
									<span style="text-transform: capitalize;" v-for="(appointment, index) in appointment_set.appointments" v-bind:key="index">
										{{getLongDateFromISO(appointment.date)}}
										<br>
									</span>
                                <span class="text-muted">
									{{appointment_set.appointments[0].chaired_admin.first_name}} {{appointment_set.appointments[0].chaired_admin.last_name}} ({{appointment_set.reservation_count}}/{{appointment_set.max_participant}})
									</span>
                                <div v-if="appointment_set.is_online">
                                    <span class='label label-default'>{{ $t('common.online')}}</span>
                                </div>

                            </td>
                            <td class="text-right" v-if="isCourse">
                                <a class="btn btn-default" href="" @click.stop.prevent="selectAppointmentSet(appointment_set)"><i class="las la-edit"></i>{{ $t('common.edit') }}</a>
                            </td>
                            <td class="text-right" v-if="!isCourse">
                                <a class="btn btn-default" href="" @click.stop.prevent="selectAppointmentSet(appointment_set)"><i class="las la-edit"></i>{{ $t('common.edit') }}</a>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                    <span class="text-muted" v-else>
						{{ $t('views.rate_detail.appointments_not_found') }}
					</span>
                </div>
                <GenericChooseModal
                        :message="$t('views.rate_detail.modal_delete_message')"
                        :title="$t('views.rate_detail.delete')"
                        :visible="deleteRateModalVisible"
                        :positive-button-text="$t('views.rate_detail.modal_delete_positive')"
                        :negative-button-text="$t('views.rate_detail.modal_delete_negative')"
                        danger
                        @positive-click-generic-modal="positiveButtonDeleteRateModalClick"
                        @negative-click-generic-modal="negativeButtonDeleteRateModalClick"
                        @close-generic-modal="negativeButtonDeleteRateModalClick"
                />
                <AddSingleAppointmentModal
                        v-show="addSingleAppointmentModalVisible"
                        :visible="addSingleAppointmentModalVisible"
                        :rate-id="rate.id"
                        @success-create-appointment="onSuccessAddAppointment"
                        @close-appointment-modal="addSingleAppointmentModalVisible=false"></AddSingleAppointmentModal>

                <AddMultipleAppointmentModal
                        v-show="addMultipleAppointmentModalVisible"
                        :visible="addMultipleAppointmentModalVisible"
                        :rate-id="rate.id"
                        @success-create-appointment="onSuccessAddMultipleAppointment"
                        @close-appointment-modal="addMultipleAppointmentModalVisible=false"
                        :appointment-count="appointmentCount"></AddMultipleAppointmentModal>

                <UpdateAppointmentModal
                        v-show="selectedAppointmentSet"
                        :visible="selectedAppointmentSet != null"
                        @success-update-appointment="onSuccessUpdateAppointment"
                        @success-delete-appointment="onSuccessDeleteAppointment"
                        @close-appointment-modal="selectedAppointmentSet=null"
                        :appointment-set-prop="selectedAppointmentSet"></UpdateAppointmentModal>
            </div>
        </div>
        <SpinnerLoader v-show="loading"></SpinnerLoader>
    </ContainerWithMenu>
</template>

<script>
    import ContainerWithMenu from "../components/container/ContainerWithMenu";
    import SpinnerLoader from "../components/common/SpinnerLoader";
    import {deleteRate, getRateDetail, updateRate} from "../api";
    import GenericChooseModal from "../components/modal/GenericChooseModal";
    import RateForm from "../components/rate/RateForm";
    import {Utils} from "../common/utils";
    import AddSingleAppointmentModal from "../components/modal/AddSingleAppointmentModal";
    import {RATE_TYPE} from "../common/constants";
    import AddMultipleAppointmentModal from "../components/modal/AddMultipleAppointmentModal";
    import UpdateAppointmentModal from "../components/modal/UpdateAppointmentModal";
    import i18n from "../i18n";

    export default {
        title: i18n.t('views.rate_detail.title'),
        name: "RateDetail",
        components: {ContainerWithMenu, SpinnerLoader, GenericChooseModal, RateForm, AddSingleAppointmentModal,
            AddMultipleAppointmentModal, UpdateAppointmentModal},
        data: function () {
            return {
                loading: false,
                rate: {},
                addSingleAppointmentModalVisible: false,
                addMultipleAppointmentModalVisible: false,
                deleteRateModalVisible: false,
                selectedAppointmentSet: null
            }
        },
        async mounted() {
            this.getRateData()
        },
        computed: {
            appointmentCount() {
                if (this.rate.appointment_count) {
                    return parseInt(this.rate.appointment_count)
                }
                return 0
            },
            isCourse() {
                if (this.rate) {
                    return this.rate.type === RATE_TYPE.COURSE
                }
                return false;
            }
        },
        methods: {
            selectAppointmentSet (appointmentSet) {
                this.selectedAppointmentSet = appointmentSet;
            },
            async getRateData() {
                this.loading = true;
                try {
                    this.rate = await getRateDetail(this.$route.params.id);
                    this.loading = false;
                } catch (e) {
                    this.loading = false;
                    console.log(e)
                }
            },
            showAddSingleAppointmentModal() {
                this.addSingleAppointmentModalVisible = true
            },
            showAddMultipleAppointmentModal() {
                this.addMultipleAppointmentModalVisible = true
            },
            showDeleteRateModal() {
                this.deleteRateModalVisible = true
            },
            async positiveButtonDeleteRateModalClick() {
                this.loading = true;
                try {
                    await deleteRate(this.rate.id);
                    this.loading = false;
                    this.deleteRateModalVisible = false;
                    this.$router.push({ name: 'rates', params: { successMessage: i18n.t('views.rate_detail.delete_success') }});
                } catch (e) {
                    this.loading = false;
                    console.log(e)
                }
            },
            negativeButtonDeleteRateModalClick() {
                this.deleteRateModalVisible = false
            },
            async saveRateClick() {
                this.loading = true;
                try {
                    await updateRate(
                        this.rate.id,
                        this.rate.type,
                        this.rate.name,
                        this.rate.duration_in_minutes,
                        this.rate.max_participant,
                        this.rate.max_participant_online,
                        this.rate.price,
                        this.rate.price_online,
                        this.rate.appointment_count);

                    this.loading = false;
                    this.$route.params.successMessage = i18n.t('views.rate_detail.update_success');
                } catch (e) {
                    this.loading = false;
                    console.log(e)
                }
            },
            onChangeRate(rate) {
                this.rate = rate;
            },
            getLongDateFromISO(date){
                return Utils.getLongDateFromISO(date)
            },
            onSuccessAddAppointment() {
                this.addSingleAppointmentModalVisible = false;
                this.getRateData()
            },
            onSuccessAddMultipleAppointment() {
                this.addMultipleAppointmentModalVisible = false;
                this.getRateData()
            },
            onSuccessUpdateAppointment() {
                this.selectedAppointmentSet = null;
                this.getRateData()
            },
            onSuccessDeleteAppointment() {
                this.selectedAppointmentSet = null;
                this.getRateData()
            }
        }
    }
</script>